"use client";

import React, { useState, useEffect } from 'react';
import { 
  FacebookShareButton, FacebookIcon,
  TwitterShareButton, TwitterIcon,
  WhatsappShareButton, WhatsappIcon,
  TelegramShareButton, TelegramIcon
} from 'react-share';

export function SocialShare({ title, text }) {
  const [url, setUrl] = useState('');

  useEffect(() => {
    // Only access window.location on the client side
    setUrl(window.location.href);
  }, []);

  if (!url) return null;

  return (
    <div className="flex items-center gap-3">
      <span className="text-sm font-medium text-foreground/75 dark:text-foreground/70 mr-2">Share:</span>
      <WhatsappShareButton url={url} title={title} separator=" - ">
        <WhatsappIcon size={36} round />
      </WhatsappShareButton>
      <FacebookShareButton url={url} quote={text}>
        <FacebookIcon size={36} round />
      </FacebookShareButton>
      <TwitterShareButton url={url} title={title}>
        <TwitterIcon size={36} round />
      </TwitterShareButton>
      <TelegramShareButton url={url} title={title}>
        <TelegramIcon size={36} round />
      </TelegramShareButton>
    </div>
  );
}
